import { Fragment } from 'react';

import {
  countryDefinitions,
  countryName,
  zipCodeFormat
} from 'common/helpers/addresses';
import { phoneFormat } from 'common/helpers/phoneHelper';

const AddressOnlyDisplay = (props) => {
  const { address } = props;
  const viewArray = countryDefinitions[address.countryCode].viewFormat;
  return (
    <>
      {renderAddressRow(viewArray, address)}
      {countryName(address.countryCode)}
      <br />
      {renderPhoneNumber(address)}
    </>
  );
};

export default AddressOnlyDisplay;

const renderAddressRow = (viewFormat, address) =>
  viewFormat.map((addressRow) => {
    // Do we need to render;
    let render = false;
    for (let i = 0; i < addressRow.length; i += 1) {
      if (address[addressRow[i]]) {
        render = true;
        break;
      }
    }
    if (!render) {
      return null;
    }
    return (
      <Fragment key={addressRow[0]}>
        {renderAddressElement(addressRow, address)}
        <br />
      </Fragment>
    );
  });

const renderAddressElement = (addressRow, address) =>
  addressRow.map((addressElement) => {
    if (addressElement === 'space') {
      return ' ';
    }
    if (addressElement === 'comma') {
      return ', ';
    }
    if (addressElement === 'zipCode') {
      return zipCodeFormat(address[addressElement], address.countryCode);
    }
    return address[addressElement];
  });

const renderPhoneNumber = (address) => {
  if (address.phone) {
    return <>Phone: {phoneFormat(address.phone, address.countryCode)}</>;
  }
  return null;
};
